import { Directive, ElementRef, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { BlurService } from '../services/blur.service';

@Directive({
  selector: '[appBlur]',
  standalone: false
})
export class BlurDirective implements OnInit, OnDestroy {
  @Input() appBlur: boolean | string = true; 
  private subscription: Subscription = new Subscription();

  constructor(
    private el: ElementRef,
    private blurService: BlurService
  ) {}

  ngOnInit(): void {

    const shouldBlur = this.appBlur === '' || this.appBlur === true || this.appBlur === 'true';
   
    this.subscription.add(
      this.blurService.blurState$.subscribe(isBlurred => {
        if (shouldBlur) {
          this.updateBlurState(isBlurred);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private updateBlurState(isBlurred: boolean): void {
    const element = this.el.nativeElement;
    
    if (isBlurred) {
      element.classList.add('global-blur');
    } else {
      element.classList.remove('global-blur');
    }
  }
}
